<ng-container *ngIf="user">
  <h1>
    Your Supply Chain
    <span class="second-title">SUPERCHARGED</span>
  </h1>

  <p class="tiles-title">Please Select One Of LYNNCO's Suite of Services Below</p>
  <div class="tiles" fxLayout="row wrap" fxLayoutGap="20pt">
    <!-- Suite Search -->
    <a *ngIf="hasAccessTo('SS')" routerLink="/suite-search/search">
      <div class="tile">
        <div class="tile__logo ss-logo"></div>
        <div class="tile__text">
          Suite
          <span class="s-color ss-color">Search</span>
        </div>
      </div>
    </a>

    <!-- Suite Link -->
    <a *ngIf="user.mercuryUsername && user.mercuryPassword && hasAccessTo('SL')"
       [href]="getSuiteLinkUrl()" target="_blank">
      <div class="tile">
        <div class="tile__logo sl-logo"></div>
        <div class="tile__text">
          Suite
          <span class="s-color sl-color">Link</span>
        </div>
      </div>
    </a>

    <!-- Suite Reports -->
    <a *ngIf="hasAccessTo('SR')" routerLink="/suite-reports">
      <div class="tile">
        <div class="tile__logo sr-logo"></div>
        <div class="tile__text">
          Suite
          <span class="s-color sr-color">Reports</span>
        </div>
      </div>
    </a>

    <!-- Suite Finance -->
    <a *ngIf="hasAccessTo('SF')" routerLink="/">
      <div class="tile">
        <div class="tile__logo sf-logo"></div>
        <div class="tile__text">
          Suite
          <span class="s-color sf-color">Finance</span>
        </div>
      </div>
    </a>

  </div>

  <div class="package"></div>
</ng-container>
